import { END } from '@confluence/navdex';

export const navdexEnd = {
	attributes: {
		navdexPointType: END,
	},
};
